import React, { Component, Suspense } from "react";
import { Provider } from 'react-redux';
import store from './store';

import { Router } from "react-router-dom";
import { history } from "./utils/helpers/history";
import Routers from "./router";

// Notification
import NotificationContainer from "./components/Shared/Notification";

// Util functions
import { scrollNavigation } from "./utils";

// Import Css
import "./assets/css/materialdesignicons.min.css";
import "./Apps.scss";
// import "./assets/css/colors/default.css";


class App extends Component {

  componentDidMount() {
    window.addEventListener("scroll", scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", scrollNavigation, true);
  }

  Loader = () => {
    return (
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        <Provider store={store}>
          <Router basename="/" history={history}>
            <Suspense fallback={this.Loader()}>
              <Routers />
            </Suspense>
          </Router>

          <NotificationContainer props /> 
          </Provider>
      </React.Fragment>
    );
  }
}

export default App;
